import { PaletteOptions, alpha } from '@mui/material';

export const palette: PaletteOptions = {
    common: {
        black: '#21272E',
        white: '#FFFFFF',
    },
    primary: {
        main: '#2196F3',
        dark: '#0C7CD5',
        light: '#E9F5FD',
        '100': '#E9F5FD',
        '300': '#BEE0FA',
    },
    secondary: {
        main: '#FF660F',
        dark: '#DB4F00',
        light: '#FF8742',
        contrastText: '#fff',
    },
    text: {
        primary: '#21272E',
    },
    grey: {
        '100': '#F7F7F8',
        '200': '#EEEFEF',
        '300': '#DEDFE0',
        '400': '#C8C9CB',
        '500': '#A7A9AC',
        '700': '#909397',
        '800': '#6F7377',
        '850': '#494E54',
        '900': '#373D43',
    },
    success: {
        main: '#7ED321',
        dark: '#06BD0E',
        contrastText: '#fff',
    },
    successDark: {
        main: '#06BD0E',
        dark: '#06BD0E',
        contrastText: '#fff',
    },
    error: {
        main: '#E2004F',
        light: '#FFE5ED',
        dark: '#C90247',
    },
    negative: {
        main: '#F94264',
        contrastText: '#fff',
    },
    warning: {
        main: '#F9A12F',
        contrastText: '#fff',
        light: '#FFF1DF',
    },
    topBar: {
        main: '#42ACC1',
        light: '#6DBFCF',
    },
    dark: {
        main: '#373D43',
        contrastText: '#fff',
    },
    light: {
        main: '#fff',
        contrastText: '#373D43',
    },
    medium: {
        main: '#909397', // grey 700
        contrastText: '#fff',
    },
    alertInfo: {
        main: '#BEE0FA',
        light: '#E9F5FD',
    },
    alertSuccess: {
        main: '#B0E972',
        light: '#E6F8D3',
    },
    alertWarning: {
        main: '#FCCE92',
        light: '#FFF1DF',
    },
    alertError: {
        main: '#FFADCA',
        light: '#FFE5ED',
    },
    action: {
        active: alpha('#21272E', 0.4), // grey 500
        hoverOpacity: 0.06,
        disabled: alpha('#21272E', 0.25), // grey 400
        disabledBackground: alpha('#21272E', 0.08), // grey 200
        hover: alpha('#21272E', 0.035), // grey 100
        selected: alpha('#21272E', 0.08), // grey 200
    },
    tableBorder: {
        main: '#e0e0e0', // material ui default color
    },
};
